import { useState } from 'react';
import { ScrollText, ChevronDown, ChevronUp } from 'lucide-react';
import type { OperationLogsData } from './overview-types';

interface Props {
  data: OperationLogsData;
}

export function OperationLogsSection({ data }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <div className="card overflow-hidden">
      <div
        className="flex items-center gap-3 border-b border-border px-5 py-4 cursor-pointer hover:bg-secondary/50"
        onClick={() => setOpen(!open)}
      >
        <ScrollText className="h-5 w-5 text-muted-foreground" />
        <h3 className="flex-1 text-sm font-semibold text-foreground">Operation Logs</h3>
        <span className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-secondary text-muted-foreground">
          {data.totalLogs} entries
        </span>
        {open ? <ChevronUp className="h-4 w-4 text-muted-foreground" /> : <ChevronDown className="h-4 w-4 text-muted-foreground" />}
      </div>

      {open && (
        <div className="p-5">
          {data.logs.length === 0 ? (
            <p className="text-sm text-muted-foreground">No operation logs in the last 30 days</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
                    <th className="pb-2 pr-4">Operator</th>
                    <th className="pb-2 pr-4">Action</th>
                    <th className="pb-2 pr-4">Category</th>
                    <th className="pb-2">Time</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border/50">
                  {data.logs.map((log, i) => (
                    <tr key={i} className="hover:bg-secondary/30">
                      <td className="py-2 pr-4 text-foreground">{log.operator}</td>
                      <td className="py-2 pr-4 text-foreground">{log.action}</td>
                      <td className="py-2 pr-4">
                        <span className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-secondary text-muted-foreground">
                          {log.categoryType || '—'}
                        </span>
                      </td>
                      <td className="py-2 text-xs text-muted-foreground">
                        {log.time ? new Date(log.time).toLocaleString() : '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
